<template>
  <div>
    <congrats-modal />
    <userHeader />
    <clarity />
    <slot />
    <sidebar />
    <chat-box />
  </div>
</template>

<script>
  import 'toastr/build/toastr.min.css'
  import 'vue-multiselect/dist/vue-multiselect.min.css'

  import Sidebar from "../components/Sidebar"
  import Header from "../components/Header"
  import _congrats_modal from "../components/_congrats_modal"
  import _chat_box from "../components/_chat_box"
  import _clarity from "../components/_clarity"

  export default {
    components: {
      'sidebar': Sidebar,
      'userHeader': Header,
      'congrats-modal': _congrats_modal,
      'chat-box': _chat_box,
      'clarity': _clarity,
    },
    name: "application"
  }
</script>
